import { Navigate } from "react-router-dom";
import { useStores } from "../../../stores/store";
import { Container } from "../container";

const PartnerRoute = ({ Component }) => {
	const { auth } = useStores();

    return auth.isPartner() ? 
        <Container>
            <Component />
        </Container>
    :
        <Navigate to="/page401" />;
};
export default PartnerRoute;